import { createStore, applyMiddleware, compose } from 'redux'
import { createLogger } from 'redux-logger'

import rootReducer from '../reducers'
import apiMiddleware from '../middlewares/apiMiddleware'

const loggerConfig = {
  collapsed: true,
}

const { NODE_ENV: env } = process.env
const production = env === 'production'
const test = env === 'test'

const middleware = applyMiddleware(...[
  apiMiddleware,
  !production && !test ? createLogger(loggerConfig) : null,
].filter(Boolean))

const composeEnhancers = production ? compose : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default createStore(
  rootReducer,
  {},
  composeEnhancers(middleware),
)
